import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';

import OrdersActionsBarPrimaryControls from './OrdersActionsBarPrimaryControls';
import OrdersActionsBarSecondaryControls from './OrdersActionsBarSecondaryControls';

const styles = () => ({
  root: {
    position: 'fixed',
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    // minWidth: 1280,
    zIndex: 1300,
  },
});

const OrdersActionsBar = ({
  open,
  count,
  totalCount,
  variant,
  onSelect,
  onDeselect,
  onSubmitSuccess,
  onRemove,
  onPrint,
  selectedOrderLines,
  orders,
  onEntered,
  onExited,
  archive,
  classes,
}) => (
  <Slide
    in={open}
    direction="up"
    mountOnEnter
    unmountOnExit
    onEntered={onEntered}
    onExited={onExited}
  >
    <Paper
      className={classes.root}
      elevation={2}
      square
    >
      <OrdersActionsBarPrimaryControls
        variant={variant}
        count={count}
        selectedOrderLines={selectedOrderLines}
        onSubmitSuccess={onSubmitSuccess}
        onRemove={onRemove}
        onPrint={onPrint}
        orders={orders}
        archive={archive}
      />
      <OrdersActionsBarSecondaryControls
        count={count}
        totalCount={totalCount}
        onSelect={onSelect}
        onDeselect={onDeselect}
      />
    </Paper>
  </Slide>
);

OrdersActionsBar.propTypes = {
  open: PropTypes.bool,
  count: PropTypes.number,
  totalCount: PropTypes.number,
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  onRemove: PropTypes.func,
  onPrint: PropTypes.func,
  selectedOrderLines: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  archive: PropTypes.bool,
  variant: PropTypes.oneOf([
    'create',
    'edit',
    'copy',
    'view',
    'intake',
    'delivery',
    'billing',
    'collection',
    'rejected',
    'combined',
  ]).isRequired,
  orders: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  onEntered: PropTypes.func,
  onExited: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersActionsBar.defaultProps = {
  open: false,
  archive: false,
  count: 0,
  totalCount: 0,
  selectedOrderLines: [],
  orders: null,
  onSelect: () => {},
  onDeselect: () => {},
  onSubmitSuccess: () => {},
  onRemove: () => {},
  onPrint: () => {},
  onEntered: () => {},
  onExited: () => {},
};

export default withStyles(styles)(OrdersActionsBar);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersActionsBar/OrdersActionsBar.js